import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../models/Common';

interface ConfirmationModalProps {
  handleClose: () => void;
  handleProceed: () => void;
  notice: string;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({ notice, handleProceed, handleClose }) => {
  const { t } = useTranslation();

  const handleContinue = () => {
    handleProceed();
    handleClose();
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('common.attention')}</article>
        <p className="modals__header__description" style={{ whiteSpace: 'pre-wrap' }}>
          {notice}
        </p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.decline')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('buttons.continue')}
          handleClick={handleContinue}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
